import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import PostCard from "../components/PostCard";
import CommentsDrawer from "../components/CommentsDrawer";
import { ArrowLeft, Hash } from "@phosphor-icons/react";

export default function Tag() {
  const { tag } = useParams();
  const [posts, setPosts] = useState(null);
  const [active, setActive] = useState(null);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get(`/hashtags/${tag.toLowerCase()}/posts`);
      setPosts(data);
    } catch (err) {
      console.error("tag load failed", err);
      setPosts([]);
    }
  }, [tag]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="relative h-[100dvh] w-full overflow-hidden bg-ink">
      <header className="absolute top-0 inset-x-0 z-30 flex items-center justify-between px-5 pt-5">
        <Link to="/" data-testid="tag-back" className="w-10 h-10 rounded-full crystal-glass flex items-center justify-center text-cream">
          <ArrowLeft size={18} />
        </Link>
        <div className="flex items-center gap-1.5 px-3 py-1.5 rounded-full crystal-glass text-cream font-black">
          <Hash size={14} weight="bold" className="text-papaya" />
          <span className="text-sm">{tag}</span>
        </div>
        <div className="w-10" />
      </header>

      {posts === null ? (
        <div className="h-full flex items-center justify-center text-cream/40 text-xs tracking-[0.3em] uppercase">Loading…</div>
      ) : posts.length === 0 ? (
        <div className="h-full flex flex-col items-center justify-center px-8 text-center">
          <Hash size={48} weight="duotone" className="text-papaya" />
          <h2 className="text-cream font-black text-2xl tracking-tighter mt-3">#{tag}</h2>
          <p className="text-cream/60 mt-2 text-sm">No posts yet — be the first to use this hashtag.</p>
          <Link to="/create" data-testid="tag-empty-cta" className="mt-5 px-5 py-2.5 rounded-full bg-papaya text-ink font-black text-xs tracking-[0.2em] uppercase">Create one</Link>
        </div>
      ) : (
        <div className="feed-snap h-[100dvh] overflow-y-scroll">
          {posts.map((p) => (
            <PostCard key={p.id} post={p} onOpenComments={setActive} onUpdate={load} />
          ))}
        </div>
      )}
      {active && <CommentsDrawer post={active} onClose={() => setActive(null)} onAdded={load} />}
    </div>
  );
}
